<div class="main-container">
  <div class="header-section">
    <div class="title-section">
      <div class="taxonomy-title">
        <span>{{ testResultData?.taxonomy_name || 'Customer - Agent Taxonomy' }}</span>
        <span class="dot">•</span>
        <span>{{ testResultData?.version || '' }}</span>
      </div>
      <img src="assets/icons/playground/slash.svg" alt="slash">

      <div class="version-title">
        <img src="assets/icons/playground/test_processed.svg" alt="processed">
        <span>{{ testResultData?.test_label || 'CS - Tag Validation' }}</span>
      </div>
    </div>
    <div class="record-section">
      <img *ngIf="testResultData?.total_processed !== testResultData?.total_records"
           src="assets/icons/playground/record_info.svg"
           alt="record info"
           matTooltip="A few records couldn't be processed. You can run tests again."
           matTooltipPosition="below"
           matTooltipClass="custom-tooltip">
      <div class="records-info">
        <span>{{ testResultData?.total_processed || 0 }}</span>
        <span>/</span>
        <span>{{ testResultData?.total_records || 0 }}</span>
        <span>Records Processed</span>
      </div>
    </div>
  </div>
  <div class="body-section">
    <!-- Table -->
    <div class="table-container">
      <table>
        <!-- Table header -->
        <thead>
          <tr class="main-header">
            <th rowspan="2" class="contact-id-header">
              <div class="header-title">
                <span>Contact ID</span>
                <div class="records-count">{{ testResultData?.total_records || 0 }} RECORDS</div>
              </div>
            </th>
            <th colspan="2">Primary Topic</th>
            <th colspan="2">Intent</th>
            <th colspan="2">Topics</th>
            <th colspan="2">Summary</th>
            <th colspan="2">Root Cause</th>
            <th colspan="2">Trigger</th>
            <th colspan="2">Customer Pain Point</th>
            <th colspan="2">Outcome</th>
            <th colspan="2">Customer Sentiment Start</th>
            <th colspan="2">Customer Sentiment End</th>
            <th colspan="2">Journey Moment</th>
            <th colspan="2">Caller Type</th>
            <th colspan="2">Call Resolution</th>
            <th colspan="2">Topics Clustered</th>
            <th colspan="2">Root Cause Clustered</th>
            <th colspan="2">Trigger Clustered</th>
            <th colspan="2">Customer Pain Point Clustered</th>
            <th colspan="2">Outcome Clustered</th>
          </tr>
          <tr class="sub-header">
            <!-- Primary Topic -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Intent -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Topics -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Summary -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Root Cause -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Trigger -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Customer Pain Point -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Outcome -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Customer Sentiment Start -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Customer Sentiment End -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Journey Moment -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Caller Type -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Call Resolution -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Topics Clustered -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Root Cause Clustered -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Trigger Clustered -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Customer Pain Point Clustered -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
            <!-- Outcome Clustered -->
            <th class="original-sample">
              <img src="assets/icons/playground/original_sample.svg" alt="original sample">
              <span>ORIGINAL SAMPLE</span>
            </th>
            <th class="test-result">
              <img src="assets/icons/playground/result_sample.svg" alt="test result">
              <span>TEST RESULT</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of records">
            <!-- Contact ID -->
            <td class="contact-id-cell">
              <div class="text-content"
                   [matTooltip]="row.contactId"
                   matTooltipClass="contact-id-tooltip"
                   matTooltipPosition="above">
              {{ row.contactId }}
              </div>
            </td>

            <!-- Primary Topic -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.primaryTopic.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                {{ row.primaryTopic.original }}
              </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.primaryTopic.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.primaryTopic.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                {{ row.primaryTopic.test }}
              </div>
            </td>

            <!-- Intent -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.intent.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                {{ row.intent.original }}
              </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.intent.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.intent.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                {{ row.intent.test }}
              </div>
            </td>

            <!-- Topics -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="getTopicsTooltip(row.topics.original)"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  <div class="chip-group" *ngIf="row.topics.original && row.topics.original.length > 0; else noTopics">
                    <span class="chip" *ngFor="let topic of row.topics.original">{{ topic }}</span>
                  </div>
                  <ng-template #noTopics>---</ng-template>
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.topics.is_changed}">
              <div class="text-content"
                   [matTooltip]="getTopicsTooltip(row.topics.test)"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  <div class="chip-group" *ngIf="row.topics.test && row.topics.test.length > 0; else noTopics">
                    <span class="chip" *ngFor="let topic of row.topics.test">{{ topic }}</span>
                  </div>
                  <ng-template #noTopics>---</ng-template>
                </div>
            </td>

            <!-- Summary -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.summary.original"
                   matTooltipClass="summary-tooltip"
                   matTooltipPosition="above">
                  {{ row.summary.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.summary.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.summary.test"
                   matTooltipClass="summary-tooltip"
                   matTooltipPosition="above">
                  {{ row.summary.test }}
                </div>
            </td>

            <!-- Root Cause -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.rootCause.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.rootCause.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.rootCause.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.rootCause.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.rootCause.test }}
                </div>
            </td>

            <!-- Trigger -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.trigger.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.trigger.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.trigger.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.trigger.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.trigger.test }}
                </div>
            </td>

            <!-- Customer Pain Point -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.customerPainPoint.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.customerPainPoint.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.customerPainPoint.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.customerPainPoint.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.customerPainPoint.test }}
                </div>
            </td>

            <!-- Outcome -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.outcome.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.outcome.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.outcome.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.outcome.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.outcome.test }}
                </div>
            </td>

            <!-- Customer Sentiment Start -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.customerSentimentStart.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.customerSentimentStart.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.customerSentimentStart.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.customerSentimentStart.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.customerSentimentStart.test }}
                </div>
            </td>

            <!-- Customer Sentiment End -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.customerSentimentEnd.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.customerSentimentEnd.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.customerSentimentEnd.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.customerSentimentEnd.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.customerSentimentEnd.test }}
                </div>
            </td>

            <!-- Journey Moment -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.journeyMoment.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.journeyMoment.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.journeyMoment.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.journeyMoment.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.journeyMoment.test }}
                </div>
            </td>

            <!-- Caller Type -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.callerType.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.callerType.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.callerType.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.callerType.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.callerType.test }}
                </div>
            </td>

            <!-- Call Resolution -->
            <td class="original-cell">
              <div class="text-content"
                   [matTooltip]="row.callResolution.original"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.callResolution.original }}
                </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.callResolution.is_changed}">
              <div class="text-content"
                   [matTooltip]="row.callResolution.test"
                   matTooltipClass="cell-tooltip"
                   matTooltipPosition="above">
                  {{ row.callResolution.test }}
                </div>
            </td>

            <!-- Topics Clustered -->
            <td class="original-cell">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.topicsClustered.original">{{ topic }}</span>
              </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.topicsClustered.is_changed}">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.topicsClustered.test">{{ topic }}</span>
              </div>
            </td>

            <!-- Root Cause Clustered -->
            <td class="original-cell">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.rootCauseClustered.original">{{ topic }}</span>
              </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.rootCauseClustered.is_changed}">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.rootCauseClustered.test">{{ topic }}</span>
              </div>
            </td>

            <!-- Trigger Clustered -->
            <td class="original-cell">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.triggerClustered.original">{{ topic }}</span>
              </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.triggerClustered.is_changed}">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.triggerClustered.test">{{ topic }}</span>
              </div>
            </td>

            <!-- Customer Pain Point Clustered -->
            <td class="original-cell">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.customerPainPointClustered.original">{{ topic }}</span>
              </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.customerPainPointClustered.is_changed}">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.customerPainPointClustered.test">{{ topic }}</span>
              </div>
            </td>

            <!-- Outcome Clustered -->
            <td class="original-cell">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.outcomeClustered.original">{{ topic }}</span>
              </div>
            </td>
            <td class="test-cell" [ngClass]="{'changed': row.outcomeClustered.is_changed}">
              <div class="chip-group">
                <span class="chip" *ngFor="let topic of row.outcomeClustered.test">{{ topic }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
